{
  "workdesk.sessions": "Oturumlar",
  "workdesk.next": "Sıradaki işler",
  "workdesk.open_panel": "{{panel}} panelini aç",
  "workdesk.close_panel": "{{panel}} panelini daralt",
  "workdesk.resize_panel": "{{panel}} panelini boyutlandır",
  "workdesk.reset_layout": "Düzeni sıfırla",
  "workdesk.resources": "Çalışma kaynakları",
  "workdesk.resume": "Devam",
  "workdesk.notes": "Notlar",
  "workdesk.maps": "Haritalar"
}
